import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormLabelComponent } from '@ui-kit/form/form-label/form-label.component';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
    selector: 'dropdown-accounts',
    standalone: true,
    imports: [FormLabelComponent, TranslateModule, FormsModule, MultiSelectModule],
    templateUrl: './dropdown-accounts.component.html',
    styleUrl: './dropdown-accounts.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownAccountsComponent {
    id = input.required<string>();
    value = model.required<any>();
    options = input.required<any[]>();

    multiple = input<boolean>(true);
    optionDisabled = input<string | undefined>(undefined);

    optionLabel = input<string>('fullName');
    optionValue = input<string>('id');
    filterBy = input<string>('fullName,email');

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);
    invalid = input<boolean>(false);
    filter = input<boolean>(true);

    size = input<'small' | 'large'>('large');

    placeholder = input<string>('uiKit.form.dropdown.placeholder');
    emptyMessage = input<string>('');
    disabled = input<boolean>(false);

    appendTo = input<string | any>('body');

    onClear = output<void>();
    onHide = output<void>();
    onFocus = output<void>();
}
